// extracted by mini-css-extract-plugin
module.exports = {"ContentItem":"ContentItem_ContentItem__2W85w","ContentText":"ContentItem_ContentText__HcFL7","Title":"ContentItem_Title__213xK","TitleAfter":"ContentItem_TitleAfter__aoRPQ"};